export const orderStatus = [
  { name: "Draft", code: "Brouillon" },
  { name: "in progress", code: "En Cours" },
  { name: "Delivered", code: "Livrée" },
  { name: "Cancelled", code: "Annulée" },
  // { name: "Payée/en attente de livraison", code: 5 },
];
export const orderPayStatus = [
  { name: "Pending", code: "En attente" },
  { name: "Deposit paid", code: "Acompte payé" },
  { name: "Paid", code: "Payée" },
];

export const getStatusSelectValue = (status, t) => {
  // const statusOptions = {
  //   1: "En attente",
  //   2: "Livrée",
  //   4: "Acompte",
  //   5: "Payée/en attente de livraison",
  // };
  return { name: status, code: t(`${status}`) };
};
